import { cs, enGB } from 'date-fns/locale';

export const locales: Record<string, Locale> = { cs, en: enGB };
